import React from 'react';

import { PageProgressContainer, PageProgressBar } from './PageProgress.style';

const LayoutProgress = ({ hidden, progress }) => (
  <PageProgressContainer hidden={hidden}>
    <PageProgressBar progress={progress} />
  </PageProgressContainer>
);

export default LayoutProgress;
